import React from 'react';
import '../../../css/Grupo1/G1Landing.css';
import KinesiologoF from '../../../Component/Grupo5/KinesiologoF';


function Kinesiologo(){

return(
      <div  >
        <KinesiologoF/>
      </div>

);


}
export default Kinesiologo;